import {
  APPROVE_WALLET_TRANSACTION_START,
  APPROVE_WALLET_TRANSACTION_SUCCESS,
  APPROVE_WALLET_TRANSACTION_ERROR,
  APPROVE_WALLET_TRANSACTION_RESET,
} from 'constants/action-types/wallets/approveWalletTransaction';
import { SUCCESS } from 'constants/notificationStatus';
import apiAction from 'helpers/apiAction';
import getMicroLoanNotifications from 'redux/actions/loanRequests/getMicroLoanNotifications';
import notify from 'helpers/notificationHelper';

const approveWalletTransaction = ({
  requestId,
  action,
  data,
  onSuccess: onSuccessCallback,
}) => dispatch =>
  dispatch(
    apiAction({
      url: `/wallets/requests/${requestId}/${action}`,
      method: 'POST',
      data,
      API_REQUEST_START: APPROVE_WALLET_TRANSACTION_START,
      API_REQUEST_SUCCESS: APPROVE_WALLET_TRANSACTION_SUCCESS,
      API_REQUEST_FAILURE: APPROVE_WALLET_TRANSACTION_ERROR,
      callbackOnSuccess: () => {
        notify({
          message: `Transaction ${
            action === 'accept' ? 'approved' : 'declined'
          } successfully`,
          status: SUCCESS,
        });
        if (onSuccessCallback) onSuccessCallback();
        getMicroLoanNotifications()(dispatch);
      },
      onEnd: () => false,
    }),
  );

export const resetApproveWalletTransaction = () => dispatch =>
  dispatch({ type: APPROVE_WALLET_TRANSACTION_RESET });

export default approveWalletTransaction;
